import { getLocale } from "../runtime";

const sv_usp1 = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Snabb hemleverans`
};

const usp1 = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_usp1(inputs)
	return "usp1";
};

export { usp1 as "usp1" };